module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0180.jpg?v=2d3fb723";